import { Text, Inset, StackChildren } from '@doordash/design-language'
import * as React from 'react'
import BackButton from '../../atoms/back-button'
import Page from '../../molecules/page'
import ScheduleOrientationFormHeader from './scheduleOrientationFormHeader'

import t from './strings'

type NoOrientationProps = {
  onBackButtonClick?: any
}
export default class NoOrientation extends React.Component<NoOrientationProps> {
  public render() {
    const { onBackButtonClick } = this.props
    return (
      <Page>
        {onBackButtonClick && <BackButton onClick={onBackButtonClick} />}
        <StackChildren>
          <ScheduleOrientationFormHeader />
          <Text styles={Text.Styles.Bold24} color={Text.Colors.TextAction}>
            {t.noOrientationH1()}
          </Text>
          <Inset isSquished={true}>
            <Text styles={Text.Styles.Regular16}>{t.noOrientationText()}</Text>
          </Inset>
        </StackChildren>
      </Page>
    )
  }
}
